

import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";

const DashboardCard = ({ subscriptionData, loading }) => {
  const [showModal, setShowModal] = useState(false);

  return(
  <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg rounded-sm border border-slate-200 p-4">
    <div className="">
      <header className="flex justify-between items-start ">
        {/* Icon */}
        {/* Menu button */}
      </header>
      <div className="flex items-start ">
        <section className="">
          <div className="product flex space-x-4">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/3/32/A_photograph_of_an_astronaut_riding_a_horse_2022-08-28.png"
              className="w-36 md:w-60 lg:w-56"
              alt="The cover of Stubborn Attachments"
              draggable="false"
            />
    <>

      {showModal ? (
        <>
          <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-center space-x-2 justify-between p-5 border-b border-solid border-gray-300 rounded-t ">
                  <h3 className="text-1xl md:text-2xl font=semibold">Do you really wanted to unsubscribe?</h3>
 
                </div>

                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  <button
                    className="text-white bg-yellow-500 active:bg-yellow-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Unsubscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>


            {loading ? (<div className="w-20"><Skeleton count={5} width={70} /> </div>) : (<div>

              <div className="flex flex-col justify-between  h-full">
                <div>
                  {subscriptionData?.subscription === "enterprise" && <>
                  <h1>You have already purchased the enterprise subscription!</h1>
                  
                  <h1         onClick={() => setShowModal(true)}
                  className="text-red-600 text-sm pl-2 pt-2 cursor-pointer font-semibold">Do you want to unsubscribe?</h1>
                  </>
                  }
                  {subscriptionData?.subscription === "premium" && <>
                  <h1>You have already purchased the premium subscription!</h1>
                                    <h1         onClick={() => setShowModal(true)}
                                    className="text-red-600 text-sm pl-2 pt-2 cursor-pointer font-semibold">Do you want to unsubscribe?</h1>
                  </>
                  }

                  {subscriptionData?.subscription === "free" && (
                <div>
                  <div className="description">
                    <h2 className="text-sm md:text-base font-bold">DesignBud Personal</h2>
                    <h5>$9.99/Month</h5>
                    <form action={`https://backend.designbud.app/create-checkout-session1/${subscriptionData.user_id}`} method="GET">
                      <button type="submit" className="text-sm mt-2 bg-transparent hover:bg-blue-500 text-blue-700 
                      font-semibold hover:text-white py-1 px-2 border border-blue-500 hover:border-transparent rounded">
                        Checkout
                      </button>
                    </form>
                  </div>

                  <hr className="mb-2 ml-2 mt-4 w-[100%]"></hr>
                  <div className="description">
                    <h2 className="text-sm md:text-base font-bold">DesignBud Enterprise</h2>
                    <h5>$99/Month</h5>
                    <form action={`https://backend.designbud.app/create-checkout-session2/${subscriptionData.user_id}`} method="GET">
                      <button type="submit" className=" text-sm mt-2 bg-transparent hover:bg-blue-500 text-blue-700 font-semibold
                       hover:text-white py-1 px-3 border border-blue-500 hover:border-transparent rounded">
                        Checkout
                      </button>
                    </form>
                  </div>
                </div>
              )}

                </div>
                {/* <h1         onClick={() => setShowModal(true)}
 className="text-red-600 text-sm pl-2 pt-2 cursor-pointer font-semibold">Do you want to unsubscribe?</h1> */}
              </div>


            </div>)}





          </div>

        </section>      {/* <div className="text-sm font-semibold text-white px-1.5 bg-green-500 rounded-full">+49%</div> */}
      </div>
    </div>
    {/* Chart built with Chart.js 3 */}
    {/* {renderHTML(someHtml)} */}

  </div>


             ) };

const Message = ({ message }) => (
  <section>
    <p>{message}</p>
  </section>
);

function DashboardCard01({ subscriptionData, loading }) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("Order placed! You will receive an email confirmation.");
    }

    if (query.get("canceled")) {
      setMessage(
        "Order canceled -- continue to shop around and checkout when you're ready."
      );
    }
  }, []);

  return message ? (
    <Message message={message} />
  ) : (
    <DashboardCard loading={loading} subscriptionData={subscriptionData} />
  );
}




export default DashboardCard01;